// XNGAGE CONFIDENTIAL
// __________________________
//
// Copyright (C) 2023 Xngage - All Rights Reserved
//
// All code or information contained herein is, and remains the
// property of Xngage LLC and its customers.  The intellectual
// and technical concepts contained are proprietary to Xngage LLC
// and may be covered by U.S. and Foreign Patents, patents in
// process, and are protected by trade secret or copyright law.
// Dissemination of this information or reproduction of this material
// is strictly forbidden unless prior written permission is obtained
// from Xngage LLC.
//

import TypographyStyle from "@insite/mobius/Typography/TypographyStyle";
import { listStyles } from "@pace/Overrides/Widgets/Brand/BrandGallery";
import { fontConfig } from "@pace/XDL/PreStyle/typography";
import { color, xScreen } from "@pace/XDL/Utilities";
import { css } from "styled-components";

listStyles.titleText = {
    variant: "h1",
    css: css`
        text-align: left;
        margin-bottom: 20px;
    `,
};

listStyles.brandsContainer = {
    css: css`
        display: flex;
        flex-wrap: wrap;
        justify-content: flex-start;
        gap: 20px;
        ${xScreen("lte", "md")} {
            gap: 24px 18px;
        }

        ${xScreen("lt", "sm")} {
            gap: 20px 16px;
            justify-content: space-evenly;
        }
    `,
};
listStyles.link = {
    css: css`
        display: flex;
        flex-direction: column;
        gap: 12px;
    `,
};
listStyles.brandItemWrapper = {
    css: css`
        box-sizing: border-box;
        border: 1px solid ${color("common.border")};
        border-radius: 4px;
        display: flex;
        justify-content: center;
        align-items: center;
        ${({ width }: any) =>
            width &&
            `
            width: ${width}px;
            height: ${width}px;

            + ${TypographyStyle}{
                max-width: ${width}px;
            }
        `}
        ${xScreen("lte", "md")} {
            width: 232px;
            height: 232px;
        }

        ${xScreen("lt", "sm")} {
            width: 156px;
            height: 156px;
        }
    `,
};
listStyles.image = {
    css: css`
        max-width: 100%;
        max-height: 100%;
        height: auto;
        ${xScreen("lt", "sm")} {
            padding: 1px;
        }
    `,
};
listStyles.brandName = {
    size: 16,
    weight: fontConfig.weight.bold,
    lineHeight: "22px",
    css: css`
        text-align: center;
    `,
};
listStyles.imageContainer = {
    css: css`
        row-gap: 20px;
    `,
};